/**
 * @file SendEmail.jsx
 * @description SendEmail component for sending emails to customers.
 * @component SendEmail
 * @exports SendEmail - Main component for sending emails to customers.
 */

import React, { useState } from "react";
import { Modal, Box, Typography, TextField, Button } from "@mui/material";
import { sendEmail } from "../../../services/customerinfoModule/historyServices";
import { getcustomerprofilebyguid } from "../../../services/customerinfoModule/profileServices";


const SendEmail = ({ customerguid }) => {
  const [open, setOpen] = useState(false);
  const [sendEmailSubject, setSendEmailSubject] = useState("");
  const [sendEmailValue, setSendEmailValue] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSendEmail = async () => {
    if (!sendEmailSubject.trim() || !sendEmailValue.trim()) {
      setErrorMsg("Subject and message cannot be empty.");
      return;
    }
    setErrorMsg("");
    setLoading(true);
    try {
      const customer = await getcustomerprofilebyguid({ customerguid });
      if (customer && customer[0].emailaddress) {
        const data = {
          emailaddress: customer[0].emailaddress,
          message: sendEmailValue,
          subject: sendEmailSubject,
          customerguid: customerguid,
          agentguid: localStorage.getItem("userguid"),
        };
        await sendEmail(data);
      }
      setSendEmailSubject("");
      setSendEmailValue("");
      setOpen(false);
    } catch (error) {
      setErrorMsg("Failed to send email. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div style={{ cursor: "pointer" }} onClick={() => setOpen(true)}>
        Send Email
      </div>
      <Modal open={open} onClose={() => setOpen(false)}>
        <Box
          sx={{
            width: 400,
            p: 3,
            bgcolor: "background.paper",
            borderRadius: 2,
            mx: "auto",
            mt: 10,
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          <Typography variant="h6">Send Email</Typography>
          <TextField
            label="Subject"
            fullWidth
            size="small"
            value={sendEmailSubject}
            onChange={(e) => setSendEmailSubject(e.target.value)}
            error={!!errorMsg && !sendEmailSubject.trim()}
          />
          <TextField
            label="Message"
            fullWidth
            value={sendEmailValue}
            onChange={(e) => setSendEmailValue(e.target.value)}
            error={!!errorMsg && !sendEmailValue.trim()}
            multiline
            minRows={4}
          />
          {errorMsg && (
            <Box sx={{ color: "red", fontSize: 13, mt: 1 }}>{errorMsg}</Box>
          )}
          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSendEmail}
              disabled={loading}
            >
              {loading ? "Sending..." : "Send"}
            </Button>
            <Button variant="outlined" onClick={() => setOpen(false)}>
              Cancel
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default SendEmail;